import { Row } from "antd";
import styled from "styled-components";

export const EditHeaderContainer = styled(Row)`
  .borderBottom {
    border-bottom: 1px solid var(--color-Light-Mode-Border-3, #dadeec);
  }
`;
